module.exports = __webpack_public_path__ + "static/media/howItWork1.750113f3.png";